module.exports = __webpack_public_path__ + "img/si.sie0de0e9.svg";